import { render, staticRenderFns } from "./DmsListLayout.vue?vue&type=template&id=2937446e&scoped=true&"
import script from "./DmsListLayout.vue?vue&type=script&lang=js&"
export * from "./DmsListLayout.vue?vue&type=script&lang=js&"
import style0 from "./DmsListLayout.vue?vue&type=style&index=0&id=2937446e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2937446e",
  null
  
)

export default component.exports